import { useContext, useEffect, useState } from 'react';
import StatCardsForEdm from './edm/StatCardsForEdm';
import ViolatorsEdmView from './edm/ViolatorsEdmView';
import PendingPaymentsEdmView from './edm/PendingPayentsEdmView';
import ComparativeAnalyticsEdmView from './edm/ComparativeAnalyticsEdmView';
import { getStatePersonalizedV2, getStates } from '../../../helpers/api';
import PageContent from '../../common/PageContent';
import { AppContext } from '../../../store/AppContext';

import {
  Box,
  CircularProgress,
  Grid2,
  TextField,
  Typography,
  Autocomplete,
  MenuItem,
} from '@mui/material';

export default function EdmDashboard() {
  const { state } = useContext(AppContext);
  const loggedInFirstName = state?.auth?.result?.data?.firstname;

  const initState = { stateId: '', stateName: '' };

  const [stateList, setStateList] = useState([]);
  const [stateLoading, setStateLoading] = useState(false);
  const [stateSelected, setStateSelected] = useState(initState);

  useEffect(() => {
    fetchStateList();
  }, []);

  const fetchStateList = async () => {
    setStateLoading(true);
    try {
      const res = await getStatePersonalizedV2();
      const { data, status } = res?.result;
      if (status?.code === '00') {
        setStateList(data);
      } else {
        openNotification({ type: 'error', message: status?.desc });
      }
    } catch (error) {
      openNotification({
        type: 'error',
        message: error?.data?.result?.status?.desc || 'Error fetching states.',
      });
    } finally {
      setStateLoading(false);
    }
  };

  const renderStatesDropdown = () => {
    return (
      <Autocomplete
        disablePortal
        value={stateSelected}
        options={stateList}
        getOptionLabel={(option) => option.stateName || ''}
        onChange={(event, newValue) => {
          if (newValue) setStateSelected(newValue);
          else setStateSelected(initState);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="All States"
            size="small"
            InputProps={{
              ...params.InputProps,
              startAdornment: stateLoading && <CircularProgress size={20} />,
              sx: {
                borderRadius: 3,
                bgcolor: 'background.paper',
              },
            }}
          />
        )}
        renderOption={(props, option) => (
          <MenuItem {...props} key={option.stateId}>
            <Typography variant="body2">{option.stateName}</Typography>
          </MenuItem>
        )}
        sx={{ width: { xs: '100%', sm: 250 } }}
      />
    );
  };

  return (
    <PageContent>
      <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: '#F4F6F8', minHeight: '100vh' }}>
        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          gap={2}
          mb={4}
        >
          <Typography variant="h4" fontWeight={700} color="text.primary">
            Hi, {loggedInFirstName} 👋
          </Typography>
          <Box width={{ xs: '100%', sm: 'auto' }}>{renderStatesDropdown()}</Box>
        </Box>

        <Box mb={4}>
          <StatCardsForEdm stateId={stateSelected?.stateId} />
        </Box>

        <Box mb={4}>
          <ComparativeAnalyticsEdmView stateId={stateSelected?.stateId} />
        </Box>

        <Grid2 container spacing={3} mb={4} alignItems="stretch">
          <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
            <ViolatorsEdmView />
          </Grid2>
          <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
            <PendingPaymentsEdmView stateId={stateSelected?.stateId} />
          </Grid2>
        </Grid2>
      </Box>
    </PageContent>
  );
}
